import {ISelection, Selection} from '@fluentui/react'

const shopifyOrderSelection: ISelection = new Selection()

export {shopifyOrderSelection}